import { GraphQLNonNull, GraphQLID } from 'graphql'
import {
  vulnerabilityFilterArgType,
  VulnerabilityFilterArg
} from './vulnerability-filter-arg'

export interface VulnerabilityAggregationArgs {
  readonly organizationID: string
  readonly filters?: VulnerabilityFilterArg
}

export const vulnerabilityAggregationArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  filters: {
    description: 'Options for filtering vulnerabilities',
    type: vulnerabilityFilterArgType
  }
}

export interface VulnerabilitySessionMetadataAggregationArgs {
  readonly applicationID: string
  readonly organizationID: string
  readonly filters?: VulnerabilityFilterArg
}

export const vulnerabilitySessionMetadataAggregationArgs = {
  applicationID: {
    description: 'The unique ID for the application being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  filters: {
    description: 'Options for filtering vulnerabilities',
    type: vulnerabilityFilterArgType
  }
}
